import { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL, baseurl } from "../../_config";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import PlayersByTeamId from "./PlayersByTeamId";

const TeamByCaptain = () => {
    const storedUserData = sessionStorage.getItem('userData');
    const userData = storedUserData ? JSON.parse(storedUserData) : null;
    const navigate = useNavigate();
    const [teamsList, setTeamsList] = useState([]);
    const [playersList, setPlayersList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("individual"); // ✅ Default tab is Team
    const params = useParams();
    const teamId = params?.id;
    const [playerByTeamData, setPlayerByTeamData] = useState([]);
    const [teamData, setTeamData] = useState([]);
    const [isIndPlayerData, setIsIndPlayerData] = useState(false);

    const fetchTeamsList = async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getTeams}`);
            if (response?.data.status === true) {
                setTeamsList(response?.data?.data)
            }
        } catch {
            return null;
        } finally {
            setLoading(false);
        }
    };

    const fetchPlayersList = async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getAllPlayers}`);
            if (response?.data.status === true) {
                setPlayersList(response?.data?.data)
            }
        } catch {
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPlayersList();
        fetchTeamsList();
    }, []);

    const teamsById = useCallback(async () => {
        if (!teamId) {
            return;
        }
        try {
            const res = await axios.get(`${baseurl}${API_URL?.getTeams}?id=${teamId}`);

            if (res?.data.status === true) {
                setTeamData(res?.data?.data[0])
            }

        } catch {
            setTeamData([])
        }
    }, [teamId]);

    useEffect(() => {
        teamsById();
    }, [teamsById]);



    const playerTeamsById = useCallback(async () => {
        if (!teamId) {
            return;
        }
        try {
            const res = await axios.get(`${baseurl}${API_URL.getPlayersByTeamId}/${teamId}}`);

            if (res?.data?.status === true) {
                setPlayerByTeamData(res?.data?.data)
            }

        } catch {
            setPlayerByTeamData([])
        }
    }, [teamId]);

    useEffect(() => {
        playerTeamsById();
    }, [playerTeamsById])

    useEffect(() => {
        if (searchTerm) {
            const filtered = teamsList?.filter(item =>
                (item.teamName && item.teamName.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.captainName && item.captainName.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.captainMobile && item.captainMobile.toString().includes(searchTerm.toString()))
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(teamsList);
        }
    }, [searchTerm, teamsList]);

    useEffect(() => {
        let data = teamsList;

        // remove players already added to team
        const usedIds = playersList
            ?.filter(p => p.individualPlayerId !== null)
            ?.map(p => p.individualPlayerId);

        data = data.filter(item => !usedIds.includes(item.id));

        // filter by tab
        if (activeTab) {
            data = data.filter(item => item.type?.toLowerCase() === activeTab.toLowerCase());
        }

        // search filter
        if (searchTerm) {
            data = data.filter(item =>
                (item.teamName && item.teamName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.captainName && item.captainName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.captainMobile && item.captainMobile.includes(searchTerm))
            );
        }

        setFilteredData(data);
    }, [searchTerm, teamsList, activeTab, playersList]);

    // useEffect(() => {
    //     let data = teamsList;

    //     // ✅ Filter by active tab
    //     if (activeTab) {
    //         data = data.filter(item => item.type?.toLowerCase() === activeTab.toLowerCase());
    //     }

    //     // ✅ Search filter
    //     if (searchTerm) {
    //         data = data.filter(item =>
    //             (item.teamName && item.teamName.toLowerCase().includes(searchTerm.toLowerCase())) ||
    //             (item.captainName && item.captainName.toLowerCase().includes(searchTerm.toLowerCase())) ||
    //             (item.captainMobile && item.captainMobile.includes(searchTerm))
    //         );
    //     }

    //     setFilteredData(data);
    // }, [searchTerm, teamsList, activeTab]);

    const handleDelete = async (teamId) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this News?");

        if (isConfirmed) {
            try {
                const response = await axios.get(`${baseurl}${API_URL?.deleteTeam}?teamId=${teamId}`);

                if (response.data.status === true) {
                    toast.success("Deleted Successfully");
                    fetchTeamsList();
                } else {
                    toast.error("Deleted Failed!");
                }
            } catch (error) {
                toast.error("Please try again later.");
            }
        }
    };

    const AddPlayer = async (item) => {
        if (playerByTeamData?.length === 13) {
            toast.error("Player limit reached. Cannot add more players.");
            return;
        }

        // Confirmation popup
        const isConfirmed = window.confirm("Are you sure you want to add this player?");
        if (!isConfirmed) {
            return; // Stop if user clicks cancel
        }

        try {
            const response = await axios.post(`${baseurl}${API_URL.addPlayers}`, {
                teamId: teamId,
                teamName: teamData?.teamName,
                players: [{
                    playersId: 0,
                    playerRole: item.teamName,
                    playerName: item.captainName,
                    individualPlayerId: item?.id
                }],
            });
            if (response?.data?.status === true) {
                toast.success("Players saved successfully!");
                teamsById();
                playerTeamsById();
                setIsIndPlayerData(false)
            } else {
                toast.error("Failed to save players");
            }
        } catch (err) {
            console.error("Error:", err);
            alert("Server error while saving players");
        }

    }

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '60px',
        },
        {
            name: activeTab === "team" ? "Team Name" : "Role",
            selector: row => (
                <div>
                    {activeTab === "team" ? (
                        <Link to={`/cricket-teams/${row.id}`}>{row.teamName}</Link>
                    ) : (
                        <p>{row.teamName}</p>
                    )}
                </div>
            ),
            sortable: true,
            minWidth: '200px'
        },
        {
            name: activeTab === "team" ? "Captain Name" : "Player Name",
            selector: row => row.captainName,
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'Email Id',
            selector: row => (
                <div className="" >
                    <h6>{row.captainEmail}</h6>
                    <span>{row?.captainMobile}</span>
                </div>
            ),
            sortable: true,
            minWidth: '250px'
        },
        {
            name: 'City',
            selector: row => row.city,
            sortable: false,
            minWidth: '100px'

        },
        {
            name: 'State',
            selector: row => row.state,
            sortable: false,
            minWidth: '100px'

        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    {playerByTeamData?.length < 13 && (
                        <span
                            onClick={() => AddPlayer(row)}
                            title="Add Player"
                            className="add_icon_wepper"
                            style={{ cursor: "pointer" }}
                        >
                            Add
                        </span>
                    )}
                    {userData?.role !== 5 && (
                        <span onClick={() => handleDelete(row?.id)} title='Delete' className="delete_icon_weepr">
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                                <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                            </svg>
                        </span>
                    )}
                </div>
            ),
            sortable: false
        },
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="right-content-section">
                <div className="admin-page mt-3 d-flex justify-content-between align-items-center">
                    <h4 className="mb-0 d-flex gap-3 align-items-center">
                        {teamId && isIndPlayerData && (
                            <button
                                type="button"
                                onClick={() => setIsIndPlayerData(false)}
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: "pointer",
                                    fontSize: "20px"
                                }}
                            >
                                <i className="fas fa-arrow-left"></i>
                            </button>
                        )}
                        <p className="mb-0">{teamData?.teamName}</p>
                    </h4>
                    {playerByTeamData?.length < 13 && (
                        <div className="d-md-flex align-items-center justify-content-end" style={{ gap: "20px" }}>
                            <div className="add_btn">
                                <button onClick={() => setIsIndPlayerData(true)}>Add Player</button>
                            </div>
                        </div>
                    )}
                </div>

                {teamId && isIndPlayerData && (
                    <div className="d-flex gap-3 mt-3">
                        <button
                            className={`btn ${activeTab === "individual" ? "btn-primary" : "btn-outline-primary"}`}
                        >
                            Individual Player List
                        </button>
                    </div>
                )}

                {isIndPlayerData ? (
                    <div className="datatable mt-4">
                        <DataTable
                            columns={columns}
                            data={filteredData || []}
                            progressPending={loading}
                            progressComponent={<p>Loading...</p>}
                            pagination
                            highlightOnHover
                        />
                    </div>
                ) : (
                    <div className="datatable mt-4">
                        <PlayersByTeamId playerByTeamData={playerByTeamData} loading={loading} />
                    </div>
                )}
            </div>
        </Layout>
    )
}

export default TeamByCaptain;